import { useEffect, useLayoutEffect } from "react";
import type { HighlightObject } from "../store/highlight-store";
import { useStores } from "./useStore";

export const useHighlightable = (obj: HighlightObject) => {
  const { highlightStore } = useStores();

  useLayoutEffect(() => {
    highlightStore.highlightObjMap.set(obj.id, obj);

    return () => {
      highlightStore.onHighlightableDeregister(obj.id, obj.ref.current);
      highlightStore.highlightObjMap.delete(obj.id);
    };
  }, [obj, highlightStore]);

  return {
    isHighlighted: highlightStore.currentHighlightId === obj.id,
    current: highlightStore.currentRef,
  };
};
